import { render, staticRenderFns } from "./salesFileManagement.vue?vue&type=template&id=512adb12&scoped=true"
import script from "./salesFileManagement.vue?vue&type=script&lang=js"
export * from "./salesFileManagement.vue?vue&type=script&lang=js"
import style0 from "./salesFileManagement.vue?vue&type=style&index=0&id=512adb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512adb12",
  null
  
)

export default component.exports